module.exports = __webpack_public_path__ + "static/media/16UNODC10.303c1b8e.jpg";